import React from 'react';
import ImageCard from './ImageCard';

const MasonryGrid = ({
  images,
  showPhotographer = true,
  showTags = false,
  photographerClickable = false,
  tagsClickable = false,
  hasMore = false,
  onLoadMore = null,
  loadingMore = false,
  loadMoreHref = null,   // SEO: real URL to next page (e.g. "/photos-hd/slug/page/2")
  prioritizeFirst = false, // give ONLY the first (above-the-fold) card LCP priority
}) => {
  if (!images || images.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20">
        <p className="text-gray-500 text-lg">No images found</p>
      </div>
    );
  }

  // SEO-friendly "Load more": progressive enhancement.
  // - The link points to a real `/page/N` URL. If JS fails, the user lands there.
  // - JS intercepts the click, runs onLoadMore (which appends photos + updates URL
  //   via history.pushState), so the visitor stays on the same scrolled page.
  const handleLoadMore = (e) => {
    if (!onLoadMore) return;       // no interceptor → let the browser follow the href
    if (loadingMore) { e.preventDefault(); return; }
    e.preventDefault();
    onLoadMore();
  };

  return (
    <div>
      <div className="columns-1 md:columns-2 lg:columns-3 px-0 md:px-4 lg:px-8 max-w-full md:max-w-[70%] mx-auto" style={{ columnGap: '25px' }}>
        {images.map((image, index) => (
          <ImageCard
            key={image.id}
            image={image}
            showPhotographer={showPhotographer}
            showTags={showTags}
            photographerClickable={photographerClickable}
            tagsClickable={tagsClickable}
            priority={prioritizeFirst && index === 0}
          />
        ))}
      </div>

      {hasMore && (loadMoreHref || onLoadMore) && (
        <div className="flex justify-center py-8 px-4">
          {loadMoreHref ? (
            <a
              href={loadMoreHref}
              onClick={handleLoadMore}
              aria-disabled={loadingMore}
              className={`w-full max-w-md border border-gray-300 rounded-lg py-4 text-center text-gray-600 hover:bg-gray-50 hover:text-gray-900 transition-colors text-sm font-medium ${loadingMore ? 'opacity-60 pointer-events-none' : ''}`}
              data-testid="load-more-btn"
              rel="next"
            >
              {loadingMore ? 'Loading...' : 'Load more'}
            </a>
          ) : (
            <button
              type="button"
              onClick={onLoadMore}
              disabled={loadingMore}
              className={`w-full max-w-md border border-gray-300 rounded-lg py-4 text-center text-gray-600 hover:bg-gray-50 hover:text-gray-900 transition-colors text-sm font-medium ${loadingMore ? 'opacity-60 pointer-events-none' : ''}`}
              data-testid="load-more-btn"
            >
              {loadingMore ? 'Loading...' : 'Load more'}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default MasonryGrid;
